import svg4everybody from 'svg4everybody';
import { isMobile } from './utils/environment'

export default function() {
    svg4everybody();

    window.isMobile = isMobile;
    if (isMobile) {
        document.documentElement.classList.add('is-mobile');
    }
}
